/**
 * purline-capture.js
 * Shared Klaviyo subscription helper + footer newsletter + back-in-stock form logic.
 */
(function () {
  'use strict';

  var KL_BASE    = 'https://a.klaviyo.com/client';
  var KL_CID     = 'RFH7aZ';
  var KL_LIST    = 'Xadg6c';
  var KL_REV     = '2024-10-15';

  /* ============================================================
     SHARED KLAVIYO HELPER
     window.purlineKlaviyoSubscribe(email, properties, eventName, eventProperties)
     Returns a Promise.
  ============================================================ */
  window.purlineKlaviyoSubscribe = function (email, properties, eventName, eventProperties) {
    properties     = properties     || {};
    eventName      = eventName      || null;
    eventProperties = eventProperties || {};

    var headers = { 'Content-Type': 'application/json', 'revision': KL_REV };

    var subRequest = fetch(KL_BASE + '/subscriptions/?company_id=' + KL_CID, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: properties.signup_source || 'Website',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: properties }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KL_LIST } } }
        }
      })
    });

    if (!eventName) return subRequest;

    return subRequest.then(function () {
      return fetch(KL_BASE + '/events/?company_id=' + KL_CID, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: eventName } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              properties: eventProperties,
              time: new Date().toISOString()
            }
          }
        })
      });
    });
  };

  /* ============================================================
     FOOTER NEWSLETTER FORM
  ============================================================ */
  function initFooterNewsletter() {
    var emailInput  = document.getElementById('purl-fn-email');
    var submitBtn   = document.getElementById('purl-fn-submit');
    var errorMsg    = document.getElementById('purl-fn-error');
    var formWrap    = document.getElementById('purl-fn-form-wrap');
    var successMsg  = document.getElementById('purl-fn-success');
    var alreadyMsg  = document.getElementById('purl-fn-already');

    if (!emailInput || !submitBtn) return;

    // Already subscribed via footer on this browser?
    try {
      if (localStorage.getItem('purline_footer_subscribed') === 'true') {
        if (formWrap)   formWrap.style.display   = 'none';
        if (alreadyMsg) alreadyMsg.style.display = 'block';
        return;
      }
    } catch (e) {}

    function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function handleSubmit() {
      var email = emailInput.value.trim();
      if (!isValidEmail(email)) {
        errorMsg.style.display = 'block';
        emailInput.focus();
        return;
      }
      errorMsg.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = '…';

      window.purlineKlaviyoSubscribe(email, {
        signup_source: 'footer',
        signup_date:   new Date().toISOString(),
        signup_page:   window.location.pathname
      }).then(function () {
        onSuccess();
      }).catch(function () {
        // Still mark success to avoid user frustration
        onSuccess();
      });
    }

    function onSuccess() {
      try { localStorage.setItem('purline_footer_subscribed', 'true'); } catch (e) {}
      if (formWrap)   formWrap.style.display   = 'none';
      if (successMsg) successMsg.style.display = 'block';
      document.dispatchEvent(new CustomEvent('purline:subscribed'));
    }

    submitBtn.addEventListener('click', handleSubmit);
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); }
    });
    emailInput.addEventListener('input', function () { errorMsg.style.display = 'none'; });
  }

  /* ============================================================
     BACK-IN-STOCK FORM
  ============================================================ */
  function initBackInStock() {
    var bisBlock = document.querySelector('.purline-bis');
    if (!bisBlock) return;

    var emailInput = bisBlock.querySelector('.purline-bis-email');
    var submitBtn  = bisBlock.querySelector('.purline-bis-btn');
    var errorMsg   = bisBlock.querySelector('.purline-bis-error');
    var innerEl    = bisBlock.querySelector('.purline-bis-inner');
    var successEl  = bisBlock.querySelector('.purline-bis-success');

    if (!emailInput || !submitBtn) return;

    var productHandle = bisBlock.dataset.productHandle || '';

    // Already requested notification for this product?
    try {
      var requested = JSON.parse(localStorage.getItem('purline_bis_products') || '[]');
      if (productHandle && requested.indexOf(productHandle) !== -1) {
        if (innerEl)   innerEl.style.display   = 'none';
        if (successEl) successEl.style.display = 'block';
        return;
      }
    } catch (e) {}

    function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function handleSubmit() {
      var email = emailInput.value.trim();
      if (!isValidEmail(email)) {
        errorMsg.style.display = 'block';
        emailInput.focus();
        return;
      }
      errorMsg.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = '…';

      // Read variant data from DOM (may have been updated by variant selector JS)
      var productTitle  = bisBlock.dataset.productTitle  || '';
      var productUrl    = bisBlock.dataset.productUrl    || '';
      var productId     = bisBlock.dataset.productId     || '';
      var productImage  = bisBlock.dataset.productImage  || '';
      var variantTitle  = bisBlock.dataset.variantTitle  || '';
      var variantId     = bisBlock.dataset.variantId     || '';

      window.purlineKlaviyoSubscribe(
        email,
        {
          signup_source:           'back_in_stock',
          back_in_stock_product:   productTitle,
          back_in_stock_url:       productUrl,
          back_in_stock_variant:   variantTitle,
          signup_date:             new Date().toISOString()
        },
        'Back In Stock Request',
        {
          product_name:  productTitle,
          product_url:   productUrl,
          product_id:    productId,
          variant_id:    variantId,
          variant_title: variantTitle,
          product_image: productImage
        }
      ).then(function () {
        onSuccess();
      }).catch(function () {
        onSuccess();
      });
    }

    function onSuccess() {
      // Save product handle to localStorage
      if (productHandle) {
        try {
          var arr = JSON.parse(localStorage.getItem('purline_bis_products') || '[]');
          if (arr.indexOf(productHandle) === -1) arr.push(productHandle);
          localStorage.setItem('purline_bis_products', JSON.stringify(arr));
        } catch (e) {}
      }
      if (innerEl)   innerEl.style.display   = 'none';
      if (successEl) successEl.style.display = 'block';
    }

    submitBtn.addEventListener('click', handleSubmit);
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); }
    });
    emailInput.addEventListener('input', function () { errorMsg.style.display = 'none'; });
  }

  /* ============================================================
     INIT
  ============================================================ */
  function init() {
    initFooterNewsletter();
    initBackInStock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
